import * as React from "react";
import {styled} from "@mui/material/styles";
import Divider, {dividerClasses} from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MuiMenuItem from "@mui/material/MenuItem";
import {paperClasses} from "@mui/material/Paper";
import {listClasses} from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon, {listItemIconClasses} from "@mui/material/ListItemIcon";
import {LogoutRounded, MoreVertRounded} from "@mui/icons-material";
import MenuButton from "./MenuButton";
import {useSignout} from "@/store/account.c";

const MenuItem = styled(MuiMenuItem)({
    margin: "2px 0",
});

export default function OptionsMenu() {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const signout = useSignout();
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <MenuButton
                aria-label="Open menu"
                onClick={handleClick}
                sx={{borderColor: "transparent"}}
            >
                <MoreVertRounded/>
            </MenuButton>
            <Menu
                anchorEl={anchorEl}
                id="menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                transformOrigin={{horizontal: "right", vertical: "top"}}
                anchorOrigin={{horizontal: "right", vertical: "bottom"}}
                sx={{
                    [`& .${listClasses.root}`]: {
                        padding: "4px",
                    },
                    [`& .${paperClasses.root}`]: {
                        padding: 0,
                    },
                    [`& .${dividerClasses.root}`]: {
                        margin: "4px -4px",
                    },
                }}
            >
                <MenuItem onClick={handleClose}>个人资料</MenuItem>
                <MenuItem onClick={handleClose}>修改密码</MenuItem>
                <Divider/>
                <MenuItem
                    onClick={() => signout()}
                    sx={{
                        [`& .${listItemIconClasses.root}`]: {
                            ml: "auto",
                            minWidth: 0,
                        },
                    }}
                >
                    <ListItemText>注销</ListItemText>
                    <ListItemIcon>
                        <LogoutRounded fontSize="small"/>
                    </ListItemIcon>
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}
